import MetricBase from "models/metrics/MetricBase";
import ConnectivityGroup from "models/groups/ConnectivityGroup";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";

class MetricNoLandingPageCount extends MetricBase {
    constructor() {
        super({
            field: "metric_noPriceCount",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.noPriceCount.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.noPriceCount.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.noPriceCount.tooltip"),
            group: new ConnectivityGroup(),
        });
    }
}

export default MetricNoLandingPageCount;
